import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "element-loading-text": "正在提交数据，请稍后",
  style: {"padding":"0 20px"}
}
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = { style: {"color":"red"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "收款单位信息", -1)
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { class: "align-middle" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 会签批核人 ")
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 执行批核人 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import moment from 'moment';
import { ref, reactive, unref, watch, onMounted } from 'vue';
import { ElForm, ElMessage, FormRules } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useAppStore } from '@/store/app';
import { RmbcCpital } from '@/utils/index';
import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
import { useUser } from '@/store/user.store';
import { GetContractApi } from '../../../apis/contract/contract.api';
import { SubPayPlanApi } from '../../../apis/PayPlans/payplan.api';
import { CpDetailApi } from '@/apis/counterpart/counterpart.api';
import BillMaterial from './material.vue';
import { triggerEvent } from 'element-plus/es/utils';
import {v4 as uuidv4} from 'uuid'


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const userStore = useUser();
const catStory = useCtCategory();

const login = useAppStore().getLoginInfo;

const elFormRef = ref<ComponentRef<typeof ElForm>>();
const BillMaterialRef = ref<InstanceType<typeof BillMaterial>>(); // 附件

const contract = ref<any>();
const planItem = ref<any>();

const formSchema = ref<any>({});


const state = reactive({
	show: false,
	load: false,
  uuid: '',
	canNotSelectd: false,
	oaPayTypeList: [] as any[],
	oaPayCodeList: [] as any[],
	oaShouTypeList: [] as any[],
	opShouTypeList: [] as any[],
	oaPayMethodList:[] as any[],
	oaPayItemList:[] as any[],
	oaKingdeeTypeList:[] as any[],
	amountCN: '',
	rules: {
		unit_name: [{ required: true, message: '请选择收款方', trigger: 'blur' }],
		amount: [{ required: true, message: '金额不能位空，且金额不能小于等于零', trigger: 'blur' }],
		pay_date: [{ required: true, message: '付款日期不能留空', trigger: 'blur' }],
		pay_type: [{ required: false, message: '收付款用途不能留空', trigger: 'blur' }],
		bank_name: [{ required: true, message: '收款银行名称不能留空', trigger: 'blur' }],
		bank_account: [{ required: true, message: '收款银行账户不能留空', trigger: 'blur' }],
		bank_account_name: [{ required: true, message: '收款公司名称不能留空', trigger: 'blur' }],
		sign_list: [{ required: true, message: '会签人员不能为空', trigger: 'change' }],
		receive_list: [{ required: true, message: '接收人列表不能为空', trigger: 'change' }],
		// oa_pay_code: [{ required: true, message: '付款申请类别未选择', trigger: 'change' }],
		oa_shou_type: [{ required: true, message: '收款单位类型未选择', trigger: 'change' }],
		kingdee_type: [{ required: true, message: '金蝶单据类型不能为空', trigger: 'change' }],
		oa_pay_code: [{ required: false, message: '申请类型不能为空', trigger: 'change' }],
		pay_method: [{ required: true, message: '结算方式不能为空', trigger: 'change' }],
		pay_item: [{ required: true, message: '费用项目不能为空', trigger: 'change' }],
		invoice_no: [{ required: false, message: '发票号码不能为空', trigger: 'blur' }],
		//is_async_kingdee: [{ required: true, message: '请选择是否集成到金蝶系统', trigger: 'change' }], //临时注释掉
	} as FormRules,
});



const load = {
	/* 读取合同信息 */
	getContractData: async (ctId: string) => {
		state.load = true;
		const { succeeded, errors, data } = await GetContractApi(ctId);
		if (!succeeded) {
			ElMessage.error(`读取合同出错，可能的原因是：${errors}`);
		} else {
			const detail = data;
			contract.value = detail;
		}
		state.load = false;
	},

};

/* 按钮操作 */
const actions = {
	/* 提交申请 */
	submit: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.load = true;

			const materialRef = unref(BillMaterialRef);
			const files = materialRef?.getFileList() ?? [];
			const formData = unref(formSchema);
			formData.file_list=files;
			formData.tableKey = state.uuid;
			const auditUsers = {
				audit_user_list: [
					{ node_id: '20204', node_name: '会签', user_list: formData.sign_list ?? [] },
					{ node_id: '20205', node_name: '接收人', user_list: formData.receive_list ?? [] },
				],
			};

			const subData = Object.assign({}, formData, auditUsers);
			const { succeeded, errors } = await SubPayPlanApi(subData);

			state.load = false;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交成功');
				$emits('refresh', unref(contract)?.id);
				state.show = false;
			}
		});
	},
};

/* 组件事件 */
const events = {
	/* 付款申请类别选择 */
	oaPayCodeChange: (val: any) => {
		unref(formSchema).oa_pay_code = val.value;
		unref(formSchema).oa_pay_name = val.label;

		// const shouTypeList = state.oaShouTypeList;
		// let shouTypeItem = { value: '供应商', label: '供应商', code: 'FKSQ001_SYS' };
		// if (shouTypeList.length) {
		// 	state.opShouTypeList = shouTypeList;
		// 	shouTypeItem = state.opShouTypeList[0];
		// 	// unref(formSchema).oa_shou_type = state.opShouTypeList[0].value;
		// 	// unref(formSchema).oa_shou_type_name = state.opShouTypeList[0].label;
		// } else {
		// 	state.opShouTypeList = state.oaShouTypeList;
		// 	// unref(formSchema).oa_shou_type = '供应商';
		// 	// unref(formSchema).oa_shou_type_name = '供应商';
		// }
		// events.oaShouTypeChange(shouTypeItem);
	},
	/* 申请类型选择 */
	oaShouTypeChange:(val: any) => {
		unref(formSchema).oa_shou_type = val.value;
		unref(formSchema).oa_shou_type_name = val.label;
	},
	/* 结算方式选择 */
	oaPayMethodChange:(val: any) => {
		unref(formSchema).pay_method = val.value;
		unref(formSchema).pay_method_name = val.label;
	},

	oaPayItemChange:(val:any) => {
		unref(formSchema).pay_item = val.value;
		unref(formSchema).pay_item_name = val.label;
	},

	/* 金蝶单据类型 */
	oaKingdeeTypeChange:(val: any) => {
		unref(formSchema).kingdee_type = val.value;
		unref(formSchema).kingdee_type_name = val.label;
		if (val.value == 'FKSQ'){
			state.rules.oa_pay_code = [{ required: true, message: '申请类型不能为空', trigger: 'blur' }];
			state.rules.pay_item = [{ required: false, message: '费用项目不能为空', trigger: 'blur' }];
			state.rules.pay_type = [{ required: true, message: '收付款用途不能留空', trigger: 'blur' }],
			unref(formSchema).pay_item = null;
		}
		else{
			state.rules.oa_pay_code = [{ required: false, message: '申请类型不能为空', trigger: 'blur' }];
			state.rules.pay_item = [{ required: true, message: '费用项目不能为空', trigger: 'blur' }];
			state.rules.pay_type = [{ required: false, message: '收付款用途不能留空', trigger: 'blur' }],
			unref(formSchema).oa_pay_code = null;
			unref(formSchema).oa_pay_name = null;
			unref(formSchema).pay_type = null;
			unref(formSchema).pay_type_code = null;
		}
		if (val.value == 'BXSQ'){
			state.rules.invoice_no = [{ required: true, message: '发票号码不能为空', trigger: 'blur' }];
		}
		else{
			state.rules.invoice_no = [{ required: false, message: '发票号码不能为空', trigger: 'blur' }];
		}
	},

	/* 收付款用途选择 */
	oaPaytypeChange: (val: any) => {
		unref(formSchema).pay_type = val.label;
		unref(formSchema).pay_type_code = val.value;
	},
	onCounterpartSelect: async (item: any) => {
		state.canNotSelectd = true;

		const { data, succeeded, errors } = await CpDetailApi(item.id);

		if (!succeeded) {
			ElMessage.warning(`读取账户信息出错，可能的原因是：${errors}。`);
		} else {
			if (!data.bank_account) {
				ElMessage.warning(`相对方银行账号信息未完善，请手动输入转账账户信息。`);
			} else {
				unref(formSchema).unit_code = data.no; //相对方编号
				unref(formSchema).unit_name = data.name; //相对方名称
				unref(formSchema).bank_name = data.bank; //开户银行名称
				unref(formSchema).bank_address = data.bank_address || ''; //开户行地址
				unref(formSchema).bank_account = data.bank_account; //银行账户
				unref(formSchema).bank_account_name = data.bank_name; //账户名称
			}
		}

		state.canNotSelectd = false;
	},
};

watch(
	() => unref(formSchema).amount,
	(newVal: number) => {
		state.amountCN = RmbcCpital(newVal);
	}
);

/* 需要暴露出去的方法 */
const methods = {
	showDialog: async (plan: any) => {
		planItem.value = plan;
		formSchema.value = {
			payplan_id: plan.id,
			amount: plan.amount,
			pay_date: moment().format('YYYY-MM-DD'),
			receive_list: [],
			sign_list: [],
			is_async_kingdee: 'N',

		};

		const { getSelectList } = useDictionary();

		state.oaPayTypeList = getSelectList('oa_pay_type');
		state.oaPayCodeList = getSelectList('oa_pay_code');
		state.oaShouTypeList = getSelectList('oa_shou_type');
		state.oaPayItemList = getSelectList('pay_item');
		state.oaPayMethodList = getSelectList('pay_method');
		state.oaKingdeeTypeList = getSelectList('kingdee_type');
		state.show = true;
		await load.getContractData(plan.contract_id);
		formSchema.value.unit_name= contract.value.counterpartList[0].name;
		events.onCounterpartSelect(contract.value.counterpartList[0])
	},
};

expose({ ...methods });

onMounted(() => {
  state.uuid = uuidv4();
  console.log(state.uuid,'uuu')
});

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(state).show) = $event)),
    title: "付款申请",
    style: {"width":"800px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).load,
        onClick: actions.submit
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).load,
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_descriptions, {
          column: 3,
          border: true,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: "申请人",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(login).user_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "部门",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(login).dept_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "申请日期",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(moment)().format('YYYY-MM-DD')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同编号",
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contract.value?.no || '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同名称",
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contract.value?.name || '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同类别",
              "label-align": "center",
              span: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(catStory).getName(contract.value?.category_id)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "我方主体",
              "label-align": "center",
              span: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contract.value?.plan_a_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项名称",
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(planItem.value?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项条件",
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(planItem.value?.pay_condition), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项金额",
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(planItem.value?.amount.toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "未付金额",
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString((planItem.value?.unpay_amt || 0).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "备注",
              "label-align": "center",
              span: "3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(planItem.value?.remark), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "采购单号",
              "label-align": "center",
              span: "3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contract.value?.purch_no), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "center" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ElForm), {
            ref_key: "elFormRef",
            ref: elFormRef,
            size: "small",
            model: formSchema.value,
            rules: _unref(state).rules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "相对方",
                        prop: "unit_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            style: {"width":"100%"},
                            modelValue: formSchema.value.unit_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.unit_name) = $event)),
                            disabled: _unref(state).canNotSelectd,
                            onChange: events.onCounterpartSelect
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contract.value?.counterpartList!, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.no,
                                  label: item.name,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "申请金额",
                        prop: "amount"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: formSchema.value.amount,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.amount) = $event)),
                            precision: 2,
                            step: 10,
                            max: planItem.value?.unpay_amt,
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "金额大写" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _unref(state).amountCN,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).amountCN) = $event)),
                            disabled: "",
                            placeholder: "请输入收款银行账户"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "金蝶单据类型",
                        prop: "kingdee_type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formSchema.value.kingdee_type_name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.kingdee_type_name) = $event)),
                            style: {"width":"100%"},
                            "value-key": "value",
                            onChange: events.oaKingdeeTypeChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaKingdeeTypeList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.label,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (formSchema.value.kingdee_type=='FKSQ')
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "申请类型",
                            prop: "oa_pay_code"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formSchema.value.oa_pay_name,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.oa_pay_name) = $event)),
                                style: {"width":"100%"},
                                filterable: "",
                                "value-key": "value",
                                onChange: events.oaPayCodeChange
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaPayCodeList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (formSchema.value.kingdee_type!='FKSQ')
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "费用项目",
                            prop: "pay_item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formSchema.value.pay_item_name,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.pay_item_name) = $event)),
                                style: {"width":"100%"},
                                filterable: "",
                                "value-key": "value",
                                onChange: events.oaPayItemChange
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaPayItemList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "收款单位类型",
                        prop: "oa_shou_type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formSchema.value.oa_shou_type,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.oa_shou_type) = $event)),
                            style: {"width":"100%"},
                            "value-key": "value",
                            onChange: events.oaShouTypeChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaShouTypeList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.label,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      (formSchema.value.kingdee_type=='FKSQ')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            filterable: "",
                            label: "收付款用途",
                            prop: "pay_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formSchema.value.pay_type,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.pay_type) = $event)),
                                style: {"width":"100%"},
                                "value-key": "value",
                                onChange: events.oaPaytypeChange
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaPayTypeList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "付款日期",
                        prop: "pay_date"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: formSchema.value.pay_date,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.pay_date) = $event)),
                            format: "YYYY-MM-DD",
                            "value-format": "YYYY-MM-DD",
                            placeholder: "请选择计划付款日期",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "结算方式",
                        prop: "pay_method"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formSchema.value.pay_method_name,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.pay_method_name) = $event)),
                            style: {"width":"100%"},
                            filterable: "",
                            "value-key": "value",
                            onChange: events.oaPayMethodChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).oaPayMethodList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.label,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "发票号码",
                        prop: "invoice_no"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: formSchema.value.invoice_no,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.invoice_no) = $event)),
                            rows: "1"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "银行账户",
                        prop: "bank_account"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            readonly: "",
                            modelValue: formSchema.value.bank_account,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.bank_account) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "账户名称",
                        prop: "bank_account_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            readonly: "",
                            modelValue: formSchema.value.bank_account_name,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.bank_account_name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "开户银行",
                        prop: "bank_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            readonly: "",
                            modelValue: formSchema.value.bank_name,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formSchema.value.bank_name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "开户行地址" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            readonly: "",
                            modelValue: formSchema.value.bank_address,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formSchema.value.bank_address) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "付款备注" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: formSchema.value.pay_remark,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formSchema.value.pay_remark) = $event)),
                            rows: "2",
                            "show-word-limit": "",
                            maxlength: "150"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "sign_list" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, [
                            _hoisted_7,
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              width: 60,
                              trigger: "hover",
                              content: "部门负责人"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { class: "align-middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_QuestionFilled)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_select_v2, {
                            class: "w100",
                            modelValue: formSchema.value.sign_list,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formSchema.value.sign_list) = $event)),
                            options: _unref(userStore).getSelectList(),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            placeholder: "请选择会签人员",
                            "tag-type": "primary"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "receive_list" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              width: 60,
                              trigger: "hover",
                              content: "财务负责人"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { class: "align-middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_QuestionFilled)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_select_v2, {
                            class: "w100",
                            modelValue: formSchema.value.receive_list,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formSchema.value.receive_list) = $event)),
                            options: _unref(userStore).getSelectList(),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            placeholder: "请选择执行人员",
                            "tag-type": "primary"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { "content-position": "center" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(BillMaterial, {
                    ref_key: "BillMaterialRef",
                    ref: BillMaterialRef,
                    "table-key": _unref(state).uuid
                  }, null, 8, ["table-key"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _unref(state).load]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})